<script>
import { widgetActions, zendeskActions } from '@state/helpers'
import ZendeskArticle from '@widgets/ZendeskArticle'
import TextArea from '@widgets/TextArea'
import { mapGetters } from 'vuex'
import deepLink from '@/mixins/deeplink.js'
import SubHeader from '@components/sub-header'

const COUPON_INFORMATION = 'couponInformation'

export default {
  name: 'CouponValidationResult',
  components: {
    ZendeskArticle,
    TextArea,
    SubHeader,
  },
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      enableButton: false,
      selectedOption: true,
    }
  },
  computed: {
    ...mapGetters('zendesk', ['computedComment']),
    ...mapGetters('widgets', ['widgetProperty']),
    buildTermsAndConditionsInformation() {
      return {
        title: this.componentData.title,
        body: this.obtaintTermsAndConditions(),
      }
    },
  },
  watch: {
    computedComment() {
      this.enableButton = false
      if (this.computedComment.body && this.computedComment.body.length > 0) {
        this.enableButton = true
      }
    },
  },
  methods: {
    setOption(option) {
      this.selectedOption = option
    },
    obtaintTermsAndConditions: function() {
      const couponInformation = this.widgetProperty(
        'CouponValidationResult',
        COUPON_INFORMATION
      )
      return couponInformation && couponInformation.body
        ? couponInformation.body
        : ''
    },
    ...zendeskActions,
    ...widgetActions,
    dispatchAction(name) {
      return this[name]()
    },
  },
}
</script>

<template>
  <div :class="$style.container">
    <ZendeskArticle
      :component-data="buildTermsAndConditionsInformation"
    />

    <div :class="$style.container__content">
      <SubHeader :text="componentData.optionListTitle"/>

      <div :class="$style.container__options">
        <BaseButton
          :seccondary="!selectedOption"
          @click="setOption(true)">{{ $t('COMMON.YES') }}</BaseButton>

        <BaseButton
          :seccondary="selectedOption"
          @click="setOption(false)">{{ $t('COMMON.NO') }}</BaseButton>
      </div>

      <TextArea
        v-show="!selectedOption"
        :component-data="componentData.textarea"/>

      <div :class="$style.container__buttons">
        <BaseButton
          v-show="!selectedOption"
          :disabled="!enableButton"
          full
          @click="dispatchAction(componentData.button.action.type)"
        >{{ componentData.button.text }}</BaseButton>

        <BaseButton
          v-show="selectedOption"
          full
          @click="callDeepLink('goto=home')"
        >{{ $t('WIDGETS.COMMON.UNDERSTOOD') }}</BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module scoped>
@import '@design';

.container {
  &__content {
    padding: 0 0.5rem 0 0.5rem;
  }

  &__buttons {
    margin: 3rem 0 3rem 0;
  }

  &__options {
    display: flex;
    width: 70%;
    margin: 0 auto;

    button {
      width: 6.5rem;
      height: 2.8rem;
      border-radius: 18px;
    }
  }
}
</style>
